import { system } from '@hover/blueprint';
import React from 'react';

export interface LineBreakProps {
  breakMobile?: boolean;
}

export const LineBreak = ({ breakMobile }: LineBreakProps) => (
  <>
    <system.br
      display={{ base: breakMobile ? 'inline' : 'none', tablet: 'inline' }}
    />
    <system.span
      display={{ base: breakMobile ? 'none' : 'inline', tablet: 'none' }}
    >
      &nbsp;
    </system.span>
  </>
);
